import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6e907551&scoped=true"
import script from "./video.js?vue&type=script&lang=js&external"
export * from "./video.js?vue&type=script&lang=js&external"
import style0 from "./style.scss?vue&type=style&index=0&id=6e907551&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e907551",
  null
  
)

export default component.exports